import { useEffect, useRef } from 'react'

import { FastlaneTrackingEvents } from 'constants/fastlane'
import { trackEvent } from 'utils/tracking'

/**
 * Triggers the `TestModeIFrameFailedToLoad` segment event when the test mode iframe widget 'start' event fails to trigger after 5 seconds
 */
export const useTrackIFrameFailedToLoad = ({
  testModeStarted,
  formUrl,
}: {
  testModeStarted: boolean
  formUrl: string
}) => {
  const trackingRef = useRef({
    testModeStarted: testModeStarted,
    formUrl,
  })

  // Store the values in a ref to make them available to the useEffect without passing them as a dependency to the useEffect
  trackingRef.current = {
    testModeStarted,
    formUrl,
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const hasTestModeStarted = trackingRef.current.testModeStarted
      if (!hasTestModeStarted) {
        trackEvent(FastlaneTrackingEvents.TestModeIFrameFailedToLoad, {
          formUrl: trackingRef.current.formUrl,
        })
      }
    }, 5000)
    return () => clearTimeout(timeoutId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
